import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=1e1a9477&"
import script from "./Configurations.vue?vue&type=script&lang=js&"
export * from "./Configurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1a9477')) {
      api.createRecord('1e1a9477', component.options)
    } else {
      api.reload('1e1a9477', component.options)
    }
    module.hot.accept("./Configurations.vue?vue&type=template&id=1e1a9477&", function () {
      api.rerender('1e1a9477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configurations.vue"
export default component.exports